export default __webpack_public_path__ + "static/media/preview.4e7df97b.jpg";